export const COARSE_POINTER_MEDIA_QUERY = "(pointer: coarse)";

/**
 * Device check, not layout check.
 * Small desktop windows do not count; this only returns true for touch-capable
 * devices whose primary pointer is coarse enough to behave like mobile input.
 */
export function getIsMobileDevice(
  browserNavigator: Navigator = navigator,
  browserWindow: Window = window,
): boolean {
  return (
    browserNavigator.maxTouchPoints > 0 &&
    browserWindow.matchMedia(COARSE_POINTER_MEDIA_QUERY).matches
  );
}

export function isIOS(browserNavigator: Navigator = navigator): boolean {
  // iPadOS can report a desktop-like Mac platform while still behaving like
  // iOS Safari for viewport and keyboard behavior, so maxTouchPoints is part
  // of the check.
  return (
    /iPad|iPhone|iPod/.test(browserNavigator.userAgent) ||
    (browserNavigator.platform === "MacIntel" &&
      browserNavigator.maxTouchPoints > 1)
  );
}

export function isFirefox(browserNavigator: Navigator = navigator): boolean {
  return /Firefox|FxiOS/.test(browserNavigator.userAgent);
}
